import { render, staticRenderFns } from "./recipients-import-fields.vue?vue&type=template&id=787697da&"
import script from "./recipients-import-fields.vue?vue&type=script&lang=js&"
export * from "./recipients-import-fields.vue?vue&type=script&lang=js&"
import style0 from "./recipients-import-fields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports